export enum MerchantPpPlusClaimMode {
  Documented = "documented",
  Undocumented = "undocumented",
}
